

<body>
  <div class="mat-elevation-z8 ccorbit-mat-table col-panel-wrapper" [cdkContextMenuTriggerFor]="context_menu">
    <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
         [ngClass]="{'expanded': colPanelOpen}">
      <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
        <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
      </div>
      <div class="col-panel-content">
        <h6 class="col-panel-title mb-2">Columnas</h6>
        <div class="col-panel-option" *ngFor="let column of tableColumns">
          <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id)" [color]="'primary'">
            {{column.name}}
          </mat-checkbox>
        </div>
      </div>
    </div>

    <cdk-virtual-scroll-viewport #viewportOperaciones [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34"
      class="wrapper mat-elevation-z2 tableStyle" *ngIf="modelo">
      <table cdk-table [dataSource]="cdkTableData" class="table-striped tableStyle">

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
          [ngClass]="{'selected': row === filaSeleccionada}"></tr>
        <ng-container *ngFor="let tablecol of tableColumns">

          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
              {{tablecol.name}}
            </th>
      <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                                'entrada': item[tablecol.id] === 'ENTRADA',
                                                                'numero-positivo': item[tablecol.id] > 0,
                                                                'numero-negativo': item[tablecol.id] < 0
                                                                }"
        [style.textAlign]="item[tablecol.id] === 'TOTAL' ? 'left' : null"
        [style.paddingLeft.px]="item[tablecol.id] === 'TOTAL' ? 10 : null">
              <ng-container *ngIf="tablecol.isString">

                {{item[tablecol.id]}} 
                 
              </ng-container>
              <ng-container *ngIf="tablecol.isDate">
                {{item[tablecol.id ] | smartDate}}
              </ng-container>
              <ng-container *ngIf="tablecol.isNumber">
                {{item[tablecol.id] | number:(item['secType'] === 'CFD' && (tablecol.id === 'precioentradareal' || tablecol.id === 'preciosalidareal') ? '1.5-5' : '1.2-2')}}
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>

    <cdk-virtual-scroll-viewport #viewportOperacionesDiv [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34"
      class="wrapper mat-elevation-z2 tableStyle" *ngIf="isPlanificador">
      <table cdk-table [dataSource]="divDataOpe" class="table-striped tableStyle">

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
          [ngClass]="{'selected': row === filaSeleccionada}"></tr>
        <ng-container *ngFor="let tablecol of tableColumns">

          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
              {{tablecol.name}}
            </th>
      <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                                'entrada': item[tablecol.id] === 'ENTRADA',
                                                                'numero-positivo': item[tablecol.id] > 0,
                                                                'numero-negativo': item[tablecol.id] < 0
                                                                }"
        [style.textAlign]="item[tablecol.id] === 'TOTAL' ? 'left' : null"
        [style.paddingLeft.px]="item[tablecol.id] === 'TOTAL' ? 10 : null">
              <ng-container *ngIf="tablecol.isString">

                {{item[tablecol.id]}}
              </ng-container>
              <ng-container *ngIf="tablecol.isDate">
                {{item[tablecol.id ] | smartDate}}
              </ng-container>
              <ng-container *ngIf="tablecol.isNumber">
                {{item[tablecol.id] | number:(item['secType'] === 'CFD' && (tablecol.id === 'precioentradareal' || tablecol.id === 'preciosalidareal') ? '1.5-5' : '1.2-2')}}
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>
    <!-- --------------- GESTOR OPERACIONES ------------------ -->
    <cdk-virtual-scroll-viewport #viewportOperacionesGest [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34"
      class="wrapper mat-elevation-z2 tableStyle" *ngIf="isGestion">
      <table cdk-table [dataSource]="GestDataOpe" class="table-striped tableStyle">

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
          [ngClass]="{'selected': row === filaSeleccionada}"></tr>
        <ng-container *ngFor="let tablecol of tableColumns">

          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
              {{tablecol.name}}
            </th>
      <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                                'entrada': item[tablecol.id] === 'ENTRADA',
                                                                'numero-positivo': item[tablecol.id] > 0,
                                                                'numero-negativo': item[tablecol.id] < 0
                                                                }"
        [style.textAlign]="item[tablecol.id] === 'TOTAL' ? 'left' : null"
        [style.paddingLeft.px]="item[tablecol.id] === 'TOTAL' ? 10 : null">
              <ng-container *ngIf="tablecol.isString">
                {{item[tablecol.id]}}
              </ng-container>
              <ng-container *ngIf="tablecol.isDate">
                {{item[tablecol.id ] | smartDate}}
              </ng-container>
              <ng-container *ngIf="tablecol.isNumber">
                {{item[tablecol.id] | number:(item['secType'] === 'CFD' && (tablecol.id === 'precioentradareal' || tablecol.id === 'preciosalidareal') ? '1.5-5' : '1.2-2')}}
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>
    <!-- --------------- BROKER OPERACIONES ------------------ -->
    <cdk-virtual-scroll-viewport #viewportOperacionesGest [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34"
      class="wrapper mat-elevation-z2 tableStyle" *ngIf="isBroker">
      <table cdk-table [dataSource]="BrokDataOpe" class="table-striped tableStyle">

        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
          [ngClass]="{'selected': row === filaSeleccionada}"></tr>
        <ng-container *ngFor="let tablecol of tableColumns">

          <ng-container [cdkColumnDef]="tablecol.id">
            <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
              {{tablecol.name}}
            </th>
      <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                                          'entrada': item[tablecol.id] === 'ENTRADA',
                                                                          'numero-positivo': item[tablecol.id] > 0,
                                                                          'numero-negativo': item[tablecol.id] < 0
                                                                          }"
        [style.textAlign]="item[tablecol.id] === 'TOTAL' ? 'left' : null"
        [style.paddingLeft.px]="item[tablecol.id] === 'TOTAL' ? 10 : null">
              <ng-container *ngIf="tablecol.isString">

                {{item[tablecol.id]}}
              </ng-container>
              <ng-container *ngIf="tablecol.isDate">
                {{item[tablecol.id ] | smartDate}}
              </ng-container>
              <ng-container *ngIf="tablecol.isNumber">
                {{item[tablecol.id] | number:(item['secType'] === 'CFD' && (tablecol.id === 'precioentradareal' || tablecol.id === 'preciosalidareal') ? '1.5-5' : '1.2-2')}}
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
      </table>
    </cdk-virtual-scroll-viewport>
  </div>
  <div class="spinner-container" *ngIf="loading">
    <mat-spinner diameter="100"></mat-spinner>
  </div>
  <ng-template #context_menu let-data="data">
    <div class="example-menu" cdkMenu [ngClass]="{'dark-theme': isDark, 'light-theme': !isDark}">
      <button class="example-menu-item" (click)="verGrafica()" cdkMenuItem>
        <mat-icon class="menu-icon">insert_chart</mat-icon>
        <span>Ver Gráfica</span>
      </button>
      <button class="example-menu-item" (click)="verModelo()" cdkMenuItem>
        <mat-icon class="menu-icon">open_in_new</mat-icon>
        <span>Ver Modelo</span>
      </button>
    </div>
  </ng-template></body>